module.exports = __webpack_public_path__ + "static/img/hebei_light.7c84e8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/hebei_light.png
// module id = 50Vg
// module chunks = 1